import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { Search } from '@mui/icons-material';
import SimpleDatePicker from '../../../ui/simpleDatePicker';
import LabSelectDialog from '../../../admin/ValidData/validLabs/labSelectDialog';

const LAB_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'sent', label: 'Sent to Lab' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

function LabOrderDialog({ open, onClose, onSave, initialData, isEdit = false }) {
  const [selectedLab, setSelectedLab] = useState(null);
  const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]);
  const [promiseDate, setPromiseDate] = useState('');
  const [rushOrder, setRushOrder] = useState(false);
  const [labInstructions, setLabInstructions] = useState('');
  const [status, setStatus] = useState('pending');
  const [labSelectDialogOpen, setLabSelectDialogOpen] = useState(false);

  const handleSave = () => {
    const labOrderData = {
      lab: selectedLab,
      orderDate,
      promiseDate,
      rushOrder,
      labInstructions,
      status
    };
    onSave(labOrderData);
    onClose();
  };

  useEffect(() => {
    
    if (initialData) {
      console.log("test")
      setSelectedLab(initialData.lab || null);
      setOrderDate(initialData.orderDate || new Date().toISOString().split('T')[0]);
      setPromiseDate(initialData.promiseDate || '');
      setRushOrder(initialData.rushOrder || false);
      setLabInstructions(initialData.labInstructions || '');
      setStatus(initialData.status || 'pending');
    }

  }, [initialData]);  

  const handleCancel = () => {
    // Reset to initial values
    setSelectedLab(initialData?.lab || null);
    setOrderDate(initialData?.orderDate || new Date().toISOString().split('T')[0]);
    setPromiseDate(initialData?.promiseDate || '');
    setRushOrder(initialData?.rushOrder || false);
    setLabInstructions(initialData?.labInstructions || '');
    setStatus(initialData?.status || 'pending');
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
        <DialogTitle>{isEdit ? 'Edit Lab Order' : 'Lab Order Details'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  {selectedLab ? `Selected Lab: ${selectedLab.name}` : 'No lab selected'}
                </Typography>            
                <Button
                  variant="outlined"
                  startIcon={<Search />}
                  onClick={() => setLabSelectDialogOpen(true)}
                  sx={{ boxShadow: 'none' }}
                >
                  Select Lab
                </Button>
              </Box>
            </Grid>
            {/* <Grid item xs={12}>
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  {selectedLab && `Address: ${selectedLab.fullAddress}`}
                </Typography>  
            </Grid> */}

            <Grid item xs={6}>
              <SimpleDatePicker
                label="Order Date"
                value={orderDate}
                onChange={setOrderDate}
                fullWidth
              />
            </Grid>
            
            <Grid item xs={6}>
              <SimpleDatePicker
                label="Promise Date"
                value={promiseDate}
                onChange={setPromiseDate}
                fullWidth
              />
            </Grid>
            
            <Grid item xs={6}>
              <FormControl fullWidth size='small'>
                <InputLabel>Status</InputLabel>
                <Select
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  {LAB_STATUSES.map((statusOption) => (
                    <MenuItem key={statusOption.value} value={statusOption.value}>
                      {statusOption.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rushOrder}
                    onChange={(e) => setRushOrder(e.target.checked)}
                  />
                }
                label="Rush Order"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                label="Lab Instructions"
                multiline
                rows={4}
                value={labInstructions}
                onChange={(e) => setLabInstructions(e.target.value)}
                fullWidth
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        
        <DialogActions>
          {isEdit ? (
            <Button 
              onClick={handleSave} 
              variant="contained" 
              disabled={!selectedLab}
              sx={{ boxShadow: 'none' }}
            >
              Update Order
            </Button>
          ) : (
            <>
              <Button 
                onClick={handleSave} 
                variant="contained" 
                disabled={!selectedLab}
                sx={{ boxShadow: 'none' }}
              >
                Save & Send later
              </Button>
              <Button 
                onClick={handleSave} 
                variant="contained" 
                disabled={!selectedLab}
                sx={{ boxShadow: 'none' }}
              >
                Save & Send
              </Button>
            </>
          )}
          <Button color='cancel' variant='outlined' onClick={handleCancel} sx={{ boxShadow: 'none' }}>
            Cancel
          </Button>                
        </DialogActions>
      </Dialog>
      
      <LabSelectDialog
        open={labSelectDialogOpen}
        onClose={() => setLabSelectDialogOpen(false)}
        onSelect={setSelectedLab}
      />
    </>
  );
}

export default LabOrderDialog;